import { getDefaultLocale } from 'modules/i18n/utils';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';
import type { SwitchLocaleSuccessAction } from '../../types';

const initialState = getDefaultLocale();

const set = (_: string, { payload }: SwitchLocaleSuccessAction): string => payload;

export default createReducer<string>(initialState, {
  [types.LOCALE_SWITCH_SUCCESS]: set,
});
